import './StatsRow.css';
import { useState } from 'react';
export default function StatsRow({
goalEnabled,
todayWords,
dailyGoal,
streak})

{
let progressIcon = "🌱";
    if(goalEnabled){
        const percentage = Math.min((todayWords/dailyGoal) * 100,100);
        if (percentage>=100) progressIcon = "🌳";
        else if(percentage>=50) progressIcon = "🌿";
    }
    return (
    <div className="stats"> 
        {goalEnabled && (           
            <div>
                <h4> Cel dzienny</h4>
                {progressIcon}{todayWords}/{dailyGoal}
            </div>
            
        )}    
        <div>
            <h4> Passa  </h4>
            {streak} 
                    
        </div>     

    </div>

    )
}